import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: '[data-component=tabs]',
  templateUrl: './tabs.component.html',
})
export class TabsComponent {
  public openTabId: string;
  @ViewChildren('tab') tabs: QueryList<ElementRef>;
  @Input() tablistTitle: string = '';
  @Input() titles: Array<string>;
  @Input() tabClass: string = '';
  @Output() onClick = new EventEmitter();
  @Input() initialTabId: string;

  constructor(private utilityService: UtilityService) {}

  ngOnInit() {
    this.init();
  }

  public init(): void {
    if (typeof this.titles === 'undefined' || this.titles.length === 0) return;

    this.openTabId = this.initialTabId || this.titles[0];
  }

  public clickTab(e: any, tabId: any): void {
    if (e != null) e.preventDefault();

    this.openTab(tabId);
  }

  public keydownTab(e: KeyboardEvent, num: number): void {
    if (!this.leftArrowKeyPressed(e) && !this.rightArrowKeyPressed(e)) return;

    let focusNum = this.rightArrowKeyPressed(e) ? num + 1 : num - 1;
    if (focusNum < 0) focusNum = this.tabs.length - 1;
    else if (focusNum >= this.tabs.length) focusNum = 0;

    this.tabs.forEach((item, i) => {
      if (i == focusNum) {
        item.nativeElement.focus();
        this.openTab(item.nativeElement.getAttribute('tabId'));
      }
    });
  }

  public stripHTML(html: string): string {
    return this.utilityService.stripHtmlTags(html, 'span');
  }

  private leftArrowKeyPressed(e: KeyboardEvent): boolean {
    return e.keyCode == 37;
  }

  private rightArrowKeyPressed(e: KeyboardEvent): boolean {
    return e.keyCode == 39;
  }

  private openTab(tabId: string): void {
    this.openTabId = tabId;
    this.onClick.emit(tabId);
  }
}
